import { useMemo } from "react";
import PropTypes from "prop-types";
import { makeApiClient } from "../apiClient";
import { noop, noopAsync, PUBLIC_BASE_URL } from "../authUtils";
import { AuthContext } from "./AuthContextCore";

export default function GuestAuthProvider({ children }) {
  const api = useMemo(() => makeApiClient(null), []);
  const publicApi = useMemo(() => makeApiClient(null, PUBLIC_BASE_URL), []);

  const contextValue = useMemo(
    () => ({
      isLoading: false,
      isLoggingOut: false,
      isAuthenticated: false,
      user: null,
      token: null,
      login: noop,
      loginFeide: noop,
      loginAdmin: noopAsync,
      loginStudent: noopAsync,
      logout: noopAsync,
      refreshToken: noopAsync,
      setVippsAuth: noopAsync,
      setFeideAuth: noopAsync,
      getVippsAccessToken: noopAsync,
      getFeideAccessToken: noopAsync,
      getAccessTokenSilently: noopAsync,
      api,
      publicApi,
    }),
    [api, publicApi],
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
}

GuestAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
